const timelineInfo = [
    {
        title: "2020.2",
        quotes: [
            {
                text:
                    "O semestre de 2020.2 foi um semestre marcado por problemas pessoais, sociais e empresariais causados pela pandemia, porém ainda trouxe aos membros vários ensinamentos sobre vivencia empresarial, uma vez que mesmo as maiores empresas sofreram com as mesmas coisas que nós sofremos.",
                author: "Thiago Reis",
            },
        ],
        directors: [
            {
                index: "Antônio Chacarosque",
                job: "Vice-Presidência",
            },
            {
                index: "Henrique Alves",
                job: "Mercado",
            },
            {
                index: "Lucas Dornelles",
                job: "Presidência",
            },
            {
                index: "Eduardo Cunha",
                job: "Projetos",
            },
            {
                index: "Thiago Reis",
                job: "Administrativo / Financeiro",
            },
        ],
        members: [
            {
                index: "Augusto Prudencio",
                job: "Gestão de Pessoas",
            },
            {
                index: "Alexandre Mattos",
                job: "Gestão de Pessoas",
            },
            {
                index: "Bianca Espíndola",
                job: "Adm / Fin",
            },
            {
                index: "Christiano Godinho",
                job: "Mercado",
            },
            {
                index: "Carlos Gomes",
                job: "Projetos",
            },
            {
                index: "Davide Clode",
                job: "Projetos",
            },
            {
                index: "Enrico Caliolo",
                job: "Adm / Fin",
            },
            {
                index: "Gabriel Rauch",
                job: "Mercado",
            },
            {
                index: "João Pedro",
                job: "Gestão de Pessoas",
            },
            {
                index: "Leomar Marschalk",
                job: "Projetos",
            },
            {
                index: "Matheus Jacks",
                job: "Projetos",
            },
            {
                index: "Paulo Duarte",
                job: "Adm / Fin",
            },
            {
                index: "Willer Castanheti",
                job: "Gestão de Pessoas",
            },
        ],
    },
    {
        title: "2020.1",
        quotes: [
            {
                text:
                    "Em meio a pandemia, tivemos que nos reinventar e trabalhar muito para superar a situação. Foi um grande desafio, mas valeu cada gota de suor.",
                author: "Raul Rosá",
            },
        ],
        directors: [
            {
                index: "Antônio Chacarosque",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Bianca Espíndola",
                job: "Gestão de Pessoas",
            },
            {
                index: "Henrique Alves",
                job: "Mercado",
            },
            {
                index: "Lucas Dornelles",
                job: "Presidência",
            },
            {
                index: "Raul Rosá",
                job: "Projetos",
            },
            {
                index: "Willian Pizoni",
                job: "Vice-Presidência",
            },
        ],
        members: [
            {
                index: "Alexandre Mattos",
                job: "Gestão de Pessoas",
            },
            {
                index: "Christiano Godinho",
                job: "Mercado",
            },
            {
                index: "Davide Clode",
                job: "Projetos",
            },
            {
                index: "Eduardo Cunha",
                job: "Projetos",
            },
            {
                index: "Felipe Tomao",
                job: "Adm / Fin",
            },
            {
                index: "João Pedro",
                job: "Gestão de Pessoas",
            },
            {
                index: "Matheus Akio",
                job: "Mercado",
            },
            {
                index: "Matheus Lima",
                job: "Mercado",
            },
            {
                index: "Nathan Marcelino",
                job: "Projetos",
            },
            {
                index: "Paulo Duarte",
                job: "Adm / Fin",
            },
            {
                index: "Thiago Reis",
                job: "Adm / Fin",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
            {
                index: "Willer Castanheti",
                job: "Gestão de Pessoas",
            },
        ],
    },
    {
        title: "2019.2",
        quotes: [
            {
                text: "Só tira 100% da EJEC quem se envolve de verdade.",
                author: "Patrick Kochan",
            },
            {
                text:
                    "Me espelho nos legados de ontem, para me tornar uma das lendas de hoje e inspirar os prodígios de amanhã.",
                author: "Antônio Chacarosque",
            },
        ],
        directors: [
            {
                index: "Lucas Dornelles",
                job: "Projetos",
            },
            {
                index: "Patrick Kochan",
                job: "Presidência",
            },
        ],
        members: [
            {
                index: "Antônio Chacarosque",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Bianca Espíndola",
                job: "Projetos",
            },
            {
                index: "Davide Clode",
                job: "Projetos",
            },
            {
                index: "Felipe Tomao",
                job: "Adm / Fin",
            },
            {
                index: "Hamilton Batti",
                job: "Adm / Fin",
            },
            {
                index: "Henrique Alves",
                job: "Comercial",
            },
            {
                index: "João Pedro",
                job: "Gestão de Pessoas",
            },
            {
                index: "Matheus Lima",
                job: "Comercial",
            },
            {
                index: "Matheus Pacheco",
                job: "Projetos",
            },
            {
                index: "Raul Rosá",
                job: "Gestão de Pessoas",
            },
            {
                index: "Rômulo Schiavon",
                job: "Comercial",
            },
            {
                index: "Samady Biasoli",
                job: "Adm / Fin",
            },
            {
                index: "Victor Camargo",
                job: "Adm / Fin",
            },
            {
                index: "Willian Pizoni",
                job: "Comercial",
            },
        ],
    },
    {
        title: "2019.1",
        quotes: [],
        directors: [
            {
                index: "Felipe Verones",
                job: "Gestão de Pessoas",
            },
            {
                index: "Hamilton Batti",
                job: "Vice-Presidência",
            },
            {
                index: "Lucas Steglich",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Jhennifer Matias",
                job: "Projetos",
            },
            {
                index: "Otávio Moratelli",
                job: "Comercial",
            },
            {
                index: "Patrick Kochan",
                job: "Presidência",
            },
        ],
        members: [
            {
                index: "Felipe Tomao",
                job: "Projetos",
            },
            {
                index: "Lucas Dornelles",
                job: "Projetos",
            },
            {
                index: "Luis Filipi",
                job: "Projetos",
            },
            {
                index: "Matheus Lima",
                job: "Gestão de Pessoas",
            },
            {
                index: "Raul Rosá",
                job: "Projetos",
            },
            {
                index: "Rodrigo Guedes",
                job: "Adm / Fin",
            },
            {
                index: "Rômulo Schiavon",
                job: "Comercial",
            },
            {
                index: "Samady Biasoli",
                job: "Adm / Fin",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
            {
                index: "Vinícius Rover",
                job: "Adm / Fin",
            },
            {
                index: "Willian Pizoni",
                job: "Comercial",
            },
        ],
    },
    {
        title: "2018.2",
        quotes: [],
        directors: [
            {
                index: "Gabriel Bittencourt",
                job: "Presidência",
            },
            {
                index: "Lucas Steglich",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Marvin Gasque",
                job: "Gestão de Pessoas",
            },
            {
                index: "Matheus Padilha",
                job: "Comercial",
            },
            {
                index: "Patrick Kochan",
                job: "Vice-Presidência",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
        ],
        members: [
            {
                index: "Felipe Tomao",
                job: "Projetos",
            },
            {
                index: "Felipe Verones",
                job: "Gestão de Pessoas",
            },
            {
                index: "Hamilton Batti",
                job: "Projetos",
            },
            {
                index: "Jhennifer Matias",
                job: "Projetos",
            },
            {
                index: "Lucas Dornelles",
                job: "Projetos",
            },
            {
                index: "Luis Filipi",
                job: "Projetos",
            },
            {
                index: "Otávio Moratelli",
                job: "Comercial",
            },
            {
                index: "Rodrigo Guedes",
                job: "Adm / Fin",
            },
            {
                index: "Vinícius Rover",
                job: "Projetos",
            },
            {
                index: "Willian Pizoni",
                job: "Comercial",
            },
        ],
    },
    {
        title: "2018.1",
        quotes: [
            {
                text:
                    "Neste ano tivemos um crescimento pessoal absurdo. Tivemos muitos desafios, projetos muito grandes que achávamos que não daríamos conta. Mas apesar de tudo, fomos um time bem unido, com uma grande amizade.",
                author: "Gabriel Bittencourt",
            },
        ],
        directors: [
            {
                index: "Gabriel Bittencourt",
                job: "Presidência",
            },
            {
                index: "Matheus Padilha",
                job: "Comercial",
            },
            {
                index: "Patrick Kochan",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Ramon Tramontin",
                job: "Projetos",
            },
        ],
        members: [
            {
                index: "Jhennifer Matias",
                job: "Projetos",
            },
            {
                index: "Luis Filipi",
                job: "Projetos",
            },
            {
                index: "Lucas Steglich",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Luiz Guilherme",
                job: "Adm / Fin",
            },
            {
                index: "Maitê Thomazi",
                job: "Adm / Fin",
            },
            {
                index: "Marcelo Keller",
                job: "Comercial",
            },
            {
                index: "Marvin Gasque",
                job: "Comercial",
            },
            {
                index: "Rodrigo Guedes",
                job: "Adm / Fin",
            },
            {
                index: "Vinícius Rover",
                job: "Projetos",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
        ],
    },
    {
        title: "2017.2",
        quotes: [
            {
                text:
                    "Foi uma experiência muito importante pra minha carreira e pra minha vida pessoal, onde eu pude aprender bastante sobre empreendedorismo, gestão de projetos e trabalho em equipe.",
                author: "Luan Lorenzo",
            },
            {
                text:
                    "Posso ter ajudado a fundar essa empresa, mas você pode ajudá-la a cada dia voar mais alto. Faça suas atividades de tal forma que permita a você sentir orgulho de tudo o que fez no futuro. Sempre existirão anos difíceis, mas não importa o que aconteça, utilize todo seu potencial que dias melhores virão, com mais e melhores projetos!",
                author: "Alan Kunz",
            },
        ],
        directors: [
            {
                index: "Ana Beatriz",
                job: "Relações Públicas",
            },
            {
                index: "Gabriel Bittencourt",
                job: "Vice-Presidência",
            },
            {
                index: "Kaio Anselmo",
                job: "Presidência",
            },
            {
                index: "Luan Lorenzo",
                job: "Projetos",
            },
            {
                index: "Matheus Padilha",
                job: "Comercial",
            },
        ],
        members: [
            {
                index: "Alan Kunz",
                job: "Projetos",
            },
            {
                index: "Luan Rodrigues",
                job: "Relações Públicas",
            },
            {
                index: "Luiz Guilherme",
                job: "Adm / Fin",
            },
            {
                index: "Maitê Thomazi",
                job: "Adm / Fin",
            },
            {
                index: "Matheus Francisco",
                job: "Projetos",
            },
            {
                index: "Patrick Kochan",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Ramon Tramontin",
                job: "Projetos",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
        ],
    },
    {
        title: "2017.1",
        quotes: [
            {
                text:
                    "Gostaria que minha história na EJEC tivesse sido maior, que eu tivesse passado mais tempo nessa empresa incrível que proporciona amizades, desenvolvimento pessoal e profissional. Foi uma experiência que vou levar para o resto da vida. É algo que tenho orgulho que faça parte de minha história.",
                author: "Alan Kunz",
            },
        ],
        directors: [
            {
                index: "Ana Beatriz",
                job: "Relações Públicas",
            },
            {
                index: "Gabriel Bittencourt",
                job: "Vice-Presidência",
            },
            {
                index: "Jonas Negri",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Kaio Anselmo",
                job: "Presidência",
            },
            {
                index: "Luan Lorenzo",
                job: "Projetos",
            },
        ],
        members: [
            {
                index: "Alan Kunz",
                job: "Projetos",
            },
            {
                index: "Gabriel Domene",
                job: "Projetos",
            },
            {
                index: "Luan Rodrigues",
                job: "Relações Públicas",
            },
            {
                index: "Luiz Guilherme",
                job: "Adm / Fin",
            },
            {
                index: "Matheus Francisco",
                job: "Relações Públicas",
            },
            {
                index: "Thiago Raulino",
                job: "Projetos",
            },
            {
                index: "Victor Camargo",
                job: "Projetos",
            },
        ],
    },
    {
        title: "2016",
        quotes: [
            {
                text:
                    "Ter essa experiência profissional e pessoal faz diferença. Um dos motivos de eu ter sido contratado, onde fiz meu estágio, foi o diferencial de ter feito parte de uma empresa júnior. Tenham muito orgulho de fazer parte desta empresa. Lembrem-se que de júnior só o nome!",
                author: "Alan Kunz",
            },
            {
                text:
                    "No setor comercial era praticamente tentativa e erro. Nós ligávamos prospectando cliente, pela internet e até mesmo pessoalmente. Vou te dizer, era uma parte bem engraçada.",
                author: "Gabriel Domene",
            },
        ],
        directors: [
            {
                index: "Alan Kunz",
                job: "Projetos",
            },
            {
                index: "Gabriel Bittencourt",
                job: "Gestão de Pessoas",
            },
            {
                index: "Heron Pereira",
                job: "Vice-Presidência",
            },
            {
                index: "Jonas Negri",
                job: "Administrativo / Financeiro",
            },
            {
                index: "Kaio Anselmo",
                job: "Presidência",
            },
            {
                index: "Thiago Raulino",
                job: "Relações Públicas",
            },
        ],
        members: [
            {
                index: "Ana Beatriz",
                job: "Relações Públicas",
            },
            {
                index: "Gabriel Domene",
                job: "Adm / Fin",
            },
            {
                index: "Matheus Francisco",
                job: "Projetos",
            },
            {
                index: "Luan Lorenzo",
                job: "Projetos",
            },
            {
                index: "Luan Rodrigues",
                job: "Relações Públicas",
            },
            {
                index: "Luiz Guilherme",
                job: "Adm / Fin",
            },
            {
                index: "Victor Camargo",
                job: "Relações Públicas",
            },
        ],
    },
];

export default timelineInfo;
